import React from "react";
import styles from "../styles/components/ContactUsTitle.module.css";
function ContactUsTitle() {
  return (
    <div className={styles.Contact}>
      <h1>Get in contact</h1>
    </div>
  );
}

export default ContactUsTitle;
